import { getFacilityByIdQueryOptions } from '@/entities/facility';
import { InfoCard } from '@/shared/components';
import { FacilityTypes } from '@/shared/constants/facilityTypes';
import { useQuery } from '@tanstack/react-query';
import type { FC } from 'react';

export type InfoCard2Props = {
  facilityId: string;
};

export const InfoCard2: FC<InfoCard2Props> = ({ facilityId }) => {
  const { data: facility, isLoading } = useQuery(
    getFacilityByIdQueryOptions({ facilityId: +facilityId })
  );

  return (
    <InfoCard
      height={116}
      list={[
        {
          id: 'livingFacility',
          label:
            facility?.types?.map((t) => FacilityTypes[t]).join(' / ') || 'N/A',
          icon: 'bordered-plus',
        },
        {
          id: 'phoneNumber',
          label: facility?.phoneNumber || 'N/A',
          icon: 'phone',
          copyable: true,
        },
        {
          id: 'address',
          label: facility?.address || 'N/A',
          icon: 'environment',
          copyable: true,
        },
      ]}
      loading={isLoading}
    />
  );
};
